import type { IRouteConfig } from '@/types/common/router';
import { AdminNames } from './routerNames';

// const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//   navigator.userAgent
// );

// const componentString = isMobile
//   ? '../views/single/mobileActivity.vue'
//   : '../views/single/activity.vue';
const title = localStorage.getItem('blank_name');
/* @vite-ignore */
export const singleRouters: IRouteConfig[] = [
  {
    path: '/',
    name: AdminNames.SingleMain,
    component: () => import('@/components/Common/BaseSingle.vue'),
    redirect: { name: AdminNames.SingleSliceHome },
    children: [
      {
        path: 'wonderful/review',
        name: AdminNames.HomeWonderfulReview,
        meta: { title: '全国高等医学院校“易创杯”形态学实验教学标本切片/玻片大赛-精彩瞬间' },
        component: () => import('../views/single/components/HomeWonderfulReview.vue')
      },
      {
        path: 'slice/home',
        name: AdminNames.SingleSliceHome,
        meta: { title: '全国高等医学院校“易创杯”形态学实验教学标本切片/玻片大赛' },
        component: () => import('../views/single/sliceHome.vue'),

      },
      {
        path: 'activity',
        name: AdminNames.SingleActivity,
        meta: { title: title },
        /* @vite-ignore */
        component: () => import('../views/single/activity.vue')
      },

    ]
  }
];
